import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';


import {getObjectValues} from 'src/modules/profile/account/tabs/admin-account-api-v2/utils/getObjectValues';
import {
    buildUniqueId,
} from 'src/modules/profile/account/tabs/admin-account-api-v2/views/controllers/limits/utils/build-unique-id';
import {getContractLimits, saveContractLimits} from 'src/openapi/admin/apis/LimitControllerApi';
import {LimitType} from 'src/openapi/admin/models/LimitType';
import {useAppDispatch} from 'src/store/hooks';

import Loading from '@pb/kit-component-loading';


import {getContractChangesInfo, makeGetContractLimitsWithIds} from '../../services/contract-selectors';
import {LimitsView} from '../limits/views/limits.view';

import type {ApiLimit} from 'src/openapi/admin/models/ApiLimit';
import type {PricingModel} from 'src/openapi/admin/models/PricingModel';
import type {AppState} from 'src/store/typedef';

type Props = {
    accountId: number,
    contractId: number,
    pricingModel: PricingModel,
    disabled?: boolean,
};

export const ContractLimitsController = (props: Props) => {
    const [busy, setBusy] = useState(false);
    const {accountId, contractId, pricingModel, disabled} = props;

    const apiDispatch = useAppDispatch();
    const selectorProps = {contractId};
    const limits = useSelector((state: AppState) => makeGetContractLimitsWithIds(state, selectorProps));
    const changesInfo = useSelector((state: AppState) => getContractChangesInfo(state, selectorProps));

    useEffect(() => {
        apiDispatch(getContractLimits({accountId, contractId, pricingModel}));
    }, [accountId, contractId, pricingModel, apiDispatch]);


    const onSaveLimits = async (newLimits: Array<ApiLimit>) => {
        // SEARCH_AND_UPDATE is deprecated and read-only; the contract endpoint rejects it on save.
        const apiLimit = newLimits.filter(limit => limit.limitType !== LimitType.SEARCH_AND_UPDATE);
        setBusy(true);
        await apiDispatch(saveContractLimits({accountId, contractId, pricingModel, apiLimit}));
        setBusy(false);
    };

    const onAddLimit = (limit: ApiLimit) => {
        const id = buildUniqueId(limit);
        if (!limits[id]) {
            onSaveLimits([...getObjectValues(limits), limit]);
        }
    };

    const onRemoveLimit = (id: string) => {

        if (!disabled && limits[id]) {
            const {[id]: _val, ...newLimits} = limits;
            onSaveLimits(getObjectValues(newLimits));
        }
    };

    return limits ? (
        <LimitsView
            {...{
                limits,
                changesInfo,
                onAddLimit,
                onRemoveLimit,
                busy,
                pricingModel,
                disabled,
                contractLevel: true,
            }}
        />
    ) : <Loading fast={true}/>;
};
